export function normalizeFrom(from: string | null): string | undefined {
  return from && from.startsWith('/') && !from.startsWith('//')
    ? from
    : undefined
}

export function getErrorMessage(error: unknown): string | undefined {
  if (typeof error === 'string') return error
  if (error instanceof Error) return error.message

  if (error && typeof error === 'object') {
    const message =
      'message' in error && typeof error.message === 'string'
        ? error.message
        : undefined
    const name =
      'name' in error && typeof error.name === 'string' ? error.name : undefined

    return [name, message].filter(Boolean).join(': ') || undefined
  }
}

export function isResolveLoadError(error: string): boolean {
  return (
    error.includes('ResolveLoadError:') ||
    error.includes('Failed to fetch dynamically imported module')
  )
}
